function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { EventNames } from "./consts";
import { getPrivacyCategories } from "./privacyCategories";
import { makeChainedFunction } from "./utils";
var dispatch = function(eventName, details) {
    var event = new CustomEvent(eventName, {
        detail: details
    });
    window.dispatchEvent(event);
};
var createReadyPromise = function() {
    var _window;
    if (typeof window === "undefined") {
        // If we're not in the browser, we can't wait for OneTrust to be ready
        return Promise.resolve({});
    }
    // If OneTrust is already available, we can resolve immediately
    if ((_window = window) == null ? void 0 : _window.OneTrust) {
        dispatch(EventNames.Ready, window.OneTrust);
        return Promise.resolve(window.OneTrust);
    }
    // window.OptanonWrapper is a function that is called by OneTrust when it is ready
    // We replace it with our own function that resolves a promise when it is called
    var isReady = false;
    var eventPromise = new Promise(function(resolve) {
        window.addEventListener(EventNames.Ready, function(event) {
            resolve(event.detail);
        }, {
            once: true
        });
    });
    var ready = function() {
        if (isReady) {
            return;
        }
        isReady = true;
        dispatch(EventNames.Ready, window.OneTrust);
    };
    // If OptanonWrapper is called dispatch the ready event
    makeChainedFunction(window, "OptanonWrapper", ready);
    // Poll for OneTrust to be ready
    (function check() {
        var _window;
        if ((_window = window) == null ? void 0 : _window.OneTrust) {
            ready();
        } else if (!isReady) {
            setTimeout(check, 16);
        }
    })();
    // We return a promise that resolves when OneTrust is ready
    // We also dispatch an event so that other modules can listen for it
    return eventPromise;
};
var wrapFunctions = function(OneTrust) {
    // We wrap these functions to make sure they're still functional if other
    // modules have already changed them
    // setup consent change event
    makeChainedFunction(OneTrust, "OnConsentChanged", /*#__PURE__*/ _async_to_generator(function() {
        var categories;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getPrivacyCategories()
                    ];
                case 1:
                    categories = _state.sent();
                    dispatch(EventNames.ConsentChanged, categories);
                    return [
                        2
                    ];
            }
        });
    }));
};
var Singleton = /*#__PURE__*/ function() {
    "use strict";
    function Singleton() {
        this.ready = createReadyPromise().then(wrapFunctions);
    }
    var _proto = Singleton.prototype;
    _proto.onReady = function onReady(callback) {
        var allowed = true;
        this.ready.then(function() {
            if (allowed) {
                callback();
            }
        });
        return function() {
            allowed = false;
        };
    };
    _proto.onConsentChanged = function onConsentChanged(callback) {
        var handler = function(event) {
            callback(event.detail);
        };
        window.addEventListener(EventNames.ConsentChanged, handler);
        return function() {
            window.removeEventListener(EventNames.ConsentChanged, handler);
        };
    };
    return Singleton;
}();
/**
 * @returns {Singleton}
 */ export var getSingleton = function() {
    var instance;
    return function() {
        if (!instance) {
            instance = new Singleton();
            // If jest testing, add resetSingleton method
            if (process.env.NODE_ENV === "test") {
                function reset() {
                    instance = new Singleton();
                    instance.resetSingleton = reset;
                }
                instance.resetSingleton = reset;
            }
        }
        return instance;
    };
}();
/**
 *
 * @param {Function} callback
 * @returns {Function} A function that can be called to remove the listener
 */ export var onReady = function(callback) {
    return getSingleton().onReady(callback);
};
/**
 * @param {Function} callback
 * @returns {Function} A function that can be called to remove the listener
 */ export var onConsentChanged = function(callback) {
    return getSingleton().onConsentChanged(callback);
};
export var whenReady = /*#__PURE__*/ _async_to_generator(function() {
    return _ts_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    getSingleton().ready
                ];
            case 1:
                return [
                    2,
                    _state.sent()
                ];
        }
    });
});
export var whenConsentChanges = function() {
    return new Promise(function(resolve) {
        var un = onConsentChanged(function(consent) {
            resolve(consent);
            un();
        });
    });
};
